/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferOrderStatusEnum = 'Offen' | 'Versendet' | 'Geschaltet' | 'Deaktiviert' | 'StorniertVorOnlineschaltung' | 'Abgelaufen' | 'InBearbeitung' | 'UpgradeLaeuft' | 'StorniertNachOnlineschaltung';

export const OfferOrderStatusEnum = {
    Offen: 'Offen' as OfferOrderStatusEnum,
    Versendet: 'Versendet' as OfferOrderStatusEnum,
    Geschaltet: 'Geschaltet' as OfferOrderStatusEnum,
    Deaktiviert: 'Deaktiviert' as OfferOrderStatusEnum,
    StorniertVorOnlineschaltung: 'StorniertVorOnlineschaltung' as OfferOrderStatusEnum,
    Abgelaufen: 'Abgelaufen' as OfferOrderStatusEnum,
    InBearbeitung: 'InBearbeitung' as OfferOrderStatusEnum,
    UpgradeLaeuft: 'UpgradeLaeuft' as OfferOrderStatusEnum,
    StorniertNachOnlineschaltung: 'StorniertNachOnlineschaltung' as OfferOrderStatusEnum
};

